export const DEFAULT_INSTANCE_NAME = 'default'

export const IOA_INSTALL_SCRIPT_FILENAME = 'Register-TenableIOA.ps1'
export const IOA_CONFIGURATION_FILENAME = 'TadIoaConfig-AllDomains.json'
